import { gql } from 'graphql.macro';

export const GetIssueList = gql`
    query GetIssueRecords($request: IssueFilterRequestInput) {
        issueRecords(request: $request) {
            observationId
            concernLevel
            locationType
            locationTypeDescription
            offSiteLocation
            {
                customerSiteName
                locationDescription
            }
            depotPcId
            depotPC
            depotPcName
            divisionId
            divisionName
            regionId
            regionName
            sHEQManagerId
            sHEQManager
            observationCategoryId
            observationCategoryName
            observationCategoryNameDE
            whatHappened
            observationStatus
            incidentDate
            processName
            reachName
        }
    }
`;
